import script from "./ChooseProjectCaptionProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseProjectCaptionProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./ChooseProjectCaptionProfileModal.vue?vue&type=style&index=0&id=0e50b464&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e50b464"]])

export default __exports__